export default __webpack_public_path__ + "static/media/logo.b716a7c0.svg";